export const scrollMessages = () => {
  setTimeout(() => {
    let elem = document.querySelector('#cce-widget-chat__messages')
    if (elem) {
      elem.scrollTop = elem.scrollHeight
    }
  })

  document.querySelectorAll(`.cce-widget-chat__attachment-img`).forEach((elem) => {
    elem.addEventListener('load', () => {
      this.scrollMessages()
    })
  })
}
